import * as preloader from '../libs/preloader'

/**
 * MV :
 *   メインビジュアルのアニメーション管理
 */

class MV {
  constructor() {
    this.slide = document.querySelector('#mvSlide')
    this.copy = document.querySelector('#mvCopy')
    this.cover = document.querySelector('#mvCover')
    this.image1 = this.slide.querySelector('.-image1')
    this.image2 = this.slide.querySelector('.-image2')
    this.image3 = this.slide.querySelector('.-image3')
    this.line1 = this.copy.querySelector('.-line1')
    this.line2 = this.copy.querySelector('.-line2')
    this.showName = '-show'
    this.animName = '-anim'
    this.slideNameArr = ['-current', '-next', '-prev']
  }

  init() {
    this.loadImage().then(() => {
      document.body.classList.add('-mv-start')
      this.showCopy()
      this.startSlide()
    })
  }

  loadImage() {
    const imageInner = this.slide.querySelectorAll('.p-mv__imageInner')
    let srcArr = []

    Array.from(imageInner, el => {
      const src = el.style.backgroundImage.replace(/(url\(|\)|")/g, '')

      if (src) {
        srcArr.push(src)
      }
    })

    return preloader.loads(srcArr)
  }

  attachEvent() {}

  showCopy() {
    this.cover.addEventListener(
      'transitionend',
      event => {
        this.line1.classList.add(this.showName)
        this.line2.classList.add(this.showName)
      },
      false
    )
  }

  startSlide() {
    this.loop(this.image1, 0)
    this.loop(this.image2, 1)
    this.loop(this.image3, 2)
  }

  loop(elem, startIdx) {
    const interval = setInterval(() => {
      // インデックスを戻す
      if (startIdx >= this.slideNameArr.length) {
        startIdx = 0
      }

      // removeするクラスのインデックス
      let prevIdx = startIdx === 0 ? 2 : startIdx - 1
      // removeするクラス名
      let prev_class = this.slideNameArr[prevIdx]
      // addするクラス名
      let next_class = this.slideNameArr[startIdx]

      elem.classList.remove(prev_class)
      elem.classList.add(next_class)

      // インデックスを１つ進めてループ
      startIdx = startIdx + 1
    }, 5000)
  }
}

export default MV



// WEBPACK FOOTER //
// ./src/script/modules/MV.js